import { render, staticRenderFns } from "./confirm-recovery-email.vue?vue&type=template&id=18f7ce59&scoped=true&"
import script from "./confirm-recovery-email.vue?vue&type=script&lang=js&"
export * from "./confirm-recovery-email.vue?vue&type=script&lang=js&"
import style0 from "./confirm-recovery-email.vue?vue&type=style&index=0&id=18f7ce59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7ce59",
  null
  
)

export default component.exports